const TYPE_COLORS = {
  STATUS: "text-cyan-300 bg-cyan-400/10 border-cyan-400/30",
  TASK: "text-violet-300 bg-violet-400/10 border-violet-400/30",
  RESULT: "text-emerald-300 bg-emerald-400/10 border-emerald-400/30",
  ALERT: "text-red-400 bg-red-500/10 border-red-500/30",
  METRICS: "text-amber-300 bg-amber-400/10 border-amber-400/30",
  EVENT: "text-blue-300 bg-blue-400/10 border-blue-400/30",
};

const PRIORITY_COLORS = {
  low: "text-neutral-400 border-neutral-700",
  normal: "text-cyan-300 border-cyan-800",
  high: "text-amber-300 border-amber-700",
  critical: "text-red-400 border-red-700",
};

export const TypeBadge = ({ type }) => (
  <span
    data-testid={`type-badge-${type?.toLowerCase()}`}
    className={`inline-block border px-2 py-0.5 font-mono text-[10px] uppercase tracking-[0.2em] ${TYPE_COLORS[type] || "text-neutral-300 bg-neutral-500/10 border-neutral-600"}`}
  >
    {type}
  </span>
);

export const PriorityBadge = ({ priority }) => (
  <span className={`inline-block border px-2 py-0.5 font-mono text-[10px] uppercase tracking-[0.15em] ${PRIORITY_COLORS[priority] || PRIORITY_COLORS.normal}`}>
    {priority}
  </span>
);

export const StatusBadge = ({ status }) => {
  const styles = {
    online: "text-[#00E676] bg-[#00E676]/10 border-[#00E676]/40",
    degraded: "text-amber-300 bg-amber-400/10 border-amber-400/40",
    offline: "text-red-400 bg-red-500/10 border-red-500/40",
    suspended: "text-sky-300 bg-sky-400/10 border-sky-400/40",
  };
  const dots = {
    online: "bg-[#00E676] animate-pulse",
    degraded: "bg-amber-300 animate-pulse",
    offline: "bg-red-500",
    suspended: "bg-sky-300",
  };
  const labels = { online: "ONLINE", degraded: "DEGRADED", offline: "OFFLINE", suspended: "SUSPENDU" };
  const s = styles[status] ? status : "offline";
  return (
    <span
      data-testid="status-badge"
      className={`inline-flex items-center gap-2 border px-2.5 py-1 font-mono text-[11px] uppercase tracking-[0.25em] ${styles[s]}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dots[s]}`} />
      {labels[s]}
    </span>
  );
};

const LEVEL_COLORS = {
  info: "text-neutral-300",
  warning: "text-amber-300",
  error: "text-red-400",
};

export const levelColor = (level) => LEVEL_COLORS[level] || "text-neutral-300";
